import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import Chip from 'modules/core/components/Filter/base/Chip'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import i18n from 'modules/core/lib/i18n'

import ClearValue from './ClearValue'
import './index.styles.css'
export type DropdownOption<T = string> = {
  label: string
  value: T
}

type DropdownProps<T = string> = {
  label: string
  options: readonly DropdownOption<T>[]
  value?: T
  onValueChange: (value?: T) => void
  defaultOpen?: boolean
  fullWidth?: boolean
  showClearOption?: boolean
  clearText?: string
  maxWidth?: string
  placeholder?: string
}

function DropdownBody<T>({
  options,
  value,
  onValueChange,
}: {
  options: readonly DropdownOption<T>[]
  value?: T
  onValueChange: (value?: T) => void
}) {
  return (
    <Box flexDirection="column">
      {options.map(({ label, value: optionValue }, index) => (
        <button
          key={index}
          className={'_Dropdown_option'}
          onClick={() => onValueChange(optionValue)}
        >
          <Text.Normal size="300" color="grey800" ellipsis>
            {label}
          </Text.Normal>
          {value === optionValue && <Icon.Medium icon="check" color="viridian1200" />}
        </button>
      ))}
    </Box>
  )
}

function Dropdown<T = string>({
  label,
  options,
  value,
  onValueChange,
  defaultOpen = false,
  fullWidth = false,
  showClearOption = true,
  clearText = i18n.t('common.clear_selection'),
  maxWidth = '240px',
  placeholder,
}: DropdownProps<T>) {
  const activeLabel = options.find((option) => option.value === value)?.label
  const active = value !== undefined && value !== null

  const handleClear = () => {
    onValueChange(undefined)
  }

  const displayLabel = active ? activeLabel : placeholder

  return (
    <Provider value={value} onValueChange={onValueChange} defaultOpen={defaultOpen}>
      <Chip.Toggler
        active={active}
        label={label}
        activeLabel={displayLabel}
        fullWidth={fullWidth}
      />
      <Content
        body={<DropdownBody options={options} value={value} onValueChange={onValueChange} />}
        footer={showClearOption ? <ClearValue onClear={handleClear} text={clearText} /> : undefined}
        maxWidth={maxWidth}
      />
    </Provider>
  )
}

export default Dropdown
